const pageNameKey = "rolesSelector";

export const rolesSelectorEn = {
  [pageNameKey]: {
    rolesLabel: "Roles",
    rolesWarningText: "A user must have at least one role.",
    noRolesText: "No available roles.",
  },
};

export const rolesSelectorPtBr = {
  [pageNameKey]: {
    rolesLabel: "Funções",
    rolesWarningText: "Um usuário deve ter pelo menos uma função.",
    noRolesText: "Nenhuma função disponível.",
  },
};

export const rolesSelectorDe = {
  [pageNameKey]: {
    rolesLabel: "Rollen",
    rolesWarningText: "Ein Benutzer muss mindestens eine Rolle haben.",
    noRolesText: "Keine verfügbaren Rollen.",
  },
};

export const rolesSelectorZhHans = {
  [pageNameKey]: {
    rolesLabel: "角色",
    rolesWarningText: "用户必须至少拥有一个角色。",
    noRolesText: "没有可用的角色。",
  },
};

export const rolesSelectorIt = {
  [pageNameKey]: {
    rolesLabel: "Ruoli",
    rolesWarningText: "Un utente deve avere almeno un ruolo.",
    noRolesText: "Nessun ruolo disponibile.",
  },
};

export const rolesSelectorEs = {
  [pageNameKey]: {
    rolesLabel: "Roles",
    rolesWarningText: "Un usuario debe tener al menos un rol.",
    noRolesText: "No hay roles disponibles.",
  },
};

export const rolesSelectorNl = {
  [pageNameKey]: {
    noRolesText: "Geen beschikbare rollen.",
    rolesLabel: "Rollen",
    rolesWarningText: "Een gebruiker moet ten minste één rol hebben.",
  },
};

export const rolesSelectorTr = {
  [pageNameKey]: {
    noRolesText: "Kullanılabilir rol yok.",
    rolesLabel: "Roller",
    rolesWarningText: "Bir kullanıcının en az bir rolü olmalıdır.",
  },
};
